import i18n from 'i18n'
import * as React from 'react'
import { IconButtonSeeker, useToaster } from 'ui-seeker/core'

import { useRemoveAlerts } from '../../hooks'


export default function IconRemoveAlerts({ idLineSelected, alertType }) {

    const { showToaster } = useToaster()
    const { removeAlerts } = useRemoveAlerts()

	const handleClick = () => {
        showToaster.confirm(`Are you sure to remove selected alerts?`, {
            onSuccess: () => {
                removeAlerts(idLineSelected, alertType)
            },
            onCancel: () => {
                showToaster.error(i18n.t('common:savedFilters.cancelled'))
            }
        })
        
	}

	return <IconButtonSeeker icon="trash-alt" iconType="fontAwesome" title={i18n.t('common:actions.removeAlerts')} onClick={handleClick} />
}